import { formatTimestamp } from '@/utils/utils';
import ctt from '@/utils/const';
// import { pointState } from '@/utils/dict';

export default {
  filters: {
    filterWsData(v) {
      if (/^30\d$/.test(v.code)) {
        if (v.code === ctt.WS_CLEAR_DANGE) {
          return ctt.POINT_STATE_GREEN;
        } else {
          return v.eventData.state;
        }
      } else if (/^20\d$/.test(v.code)) {
        return ctt.POINT_STATE_GREEN;
      } else if (/^50\d$/.test(v.code)) {
        return ctt.POINT_STATE_DANGER;
      } else {
        return v.state;
      }
    }
  },
  data() {
    return {
      modsKey: [
        'weatherMod',
        'tvocMod',
        'smokeMod',
        'bioMod',
        'cwaMod',
        'nuclearMod',
        'gcameraMod',
        'sysMod',
        'detectionMode'
      ]
    };
  },
  methods: {
    warnText(code, state) {
      // 报警信息
      if (code === ctt.WS_DANGE1) {
        if (state === ctt.POINT_STATE_WARN) {
          return '发生预警事件';
        } else {
          return '发生报警事件';
        }
      } else if (code === ctt.WS_DANGE2) {
        if (state === ctt.POINT_STATE_WARN) {
          return '降级为预警事件';
        } else {
          return '升级为报警事件';
        }
      } else if (code === ctt.WS_CLEAR_DANGE) {
        return '报警解除';
      }
    },
    reportText(item) {
      const { warnText } = this;
      const { code } = item;
      if (/^30\d$/.test(code)) {
        const warnStr = this.$t(warnText(code, item.eventData.state));

        const date =
          item.eventData.endTime === 0
            ? formatTimestamp(item.eventData.beginTime)
            : formatTimestamp(item.eventData.endTime);

        return this.$t('设备详细信息模板', {
          date,
          deviceName: item.deviceName + '',
          sn: item.eventData.sn,
          warnStr,
          msg: item.eventData.message
        });
      } else if (code === 200) {
        return item.data;
      } else if (code === 500) {
        return this.$t('断开连接模板', {
          date: formatTimestamp(parseInt(item.dateTime))
        });
      } else if (code === ctt.WS_BASIC) {
        const { modState } = item;

        let text = '';

        for (let k in modState) {
          const modName = this.$t(k);
          const defaultName = this.$t('numericalValue');

          text += this.$t('传感器状态模板', {
            modName: modName || defaultName,
            modState: modState[k].trend
          });
        }

        return this.$t('传感器消息模板', {
          date: formatTimestamp(item.beginTime),
          name: item.name,
          sn: item.sn,
          msg: text
        });
      }
    }
  }
};
